// extracted by mini-css-extract-plugin
export var cardHeader = "_hn-0";
export var reorderHandle = "_hn-3";
export var titleArea = "_hn-1";
export var titleAreaWithHandle = "_hn-2";